import { CopyToClipboard } from "react-copy-to-clipboard";
import { toastr } from "react-redux-toastr";

const ClipboardCopy = ({ text }) => {
  if (!text) {
    return null;
  }
  return (
    <CopyToClipboard
      text={text}
      onCopy={() => toastr.success("Sukces", `${text} - skopiowano do schowka`)}
    >
      <span className="text-copy">{text}</span>
    </CopyToClipboard>
  );
};

export default ClipboardCopy;
